import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AdminView from '@/views/SmartLink/Admin/AdminView.vue';
import AdminUser from '@/components/RAOS/Management/AdminUser.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "ml-4" }, " Equipos ", -1)),
    _createVNode(AdminView),
    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "ml-4" }, " Usuarios ", -1)),
    _createVNode(AdminUser)
  ], 64))
}
}

})